// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2I7pS","requiredAsterisk":"Info_requiredAsterisk__fyqWH"};